//import city from './city.json'
import { Tacitly } from "./Tacitly";
import { Modal } from "ant-design-vue";
import { outForm } from "@/server/api";
import common from "./common";
export function sum(arr) {
  return arr.reduce(function (prev, curr, idx, arr) {
    return prev + curr;
  });
}

export function Filetype(url) {
  //0 视频 1音乐 2pdf  3图片 4 word
  if (url) {
    const type = {
      0: ["mp4"], //视频
      1: ["mp3", "ogg"], //音频
      2: ["pdf", "ofd"], //pdf
      3: ["bmp", "jpg", "png", "gif", "jpeg"], //图片
      4: [
        "doc",
        "docx",
        "docm",
        "dotx",
        "xls",
        "xlsx",
        "xlsm",
        "xltx",
        "xltm",
        "xlsb",
        "xlam",
        "PPt",
        "pptx",
        "pptm",
        "ppsx",
        "ppsm",
      ], //文件
      5: ["m4a"],
      6: ["amr"],
      7: ["zip", "rar", "7Z", "txt"],
    };

    let suffix = url.slice(url.lastIndexOf(".") + 1);
    for (let val in type) {
      if (type[val].indexOf(suffix.toLowerCase()) >= 0) {
        return val.toLowerCase();
      }
    }
  }
}

export function citySort(city) {
  city.sort((pre, next) => {
    return pre.first_char.charCodeAt(0) - next.first_char.charCodeAt(0);
  });
  return city;
}

export function exportForm(type, form) {
  let http = Tacitly.Base_Port;
  for (let val in form) {
    if (!form[val]) {
      delete form[val];
    }
    if (typeof form[val] == "object") {
      form[val] = form[val].toString();
    }
  }
  // if (bool) {
  //   form.step = this.$parent.stepCode.toString()
  // }
  Modal.confirm({
    content: "确认导出这个文件？",
    onOk: () => {
      window.open(http + outForm(type, common.urlEncode(form)));
    },
  });
}
